<template>
  <v-container>
    <h1 class="text-capitalize">{{ $t('common.privacy-policy')}}</h1>
    <v-skeleton-loader
      :loading="loading"
      :transition="transition"
      type="article"
    >
    <div>
      <prismic-rich-text :field="body"/>
    </div>
    </v-skeleton-loader>
  </v-container>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  data: () => ({
    loading: true,
    transition: 'scale-transition',
    body: null,
  }),
  created() {
    this.getContent();
  },
  methods: {
    getContent() {
      this.$prismic.client.getSingle('privacy_policy', { lang: this.$i18n.locale })
        .then((document) => {
          this.body = document.data.body;
          this.loading = false;
        });
    },
    signUp() {

    },
  },
};
</script>

<style scoped>

</style>
